import { useQuery } from "@tanstack/react-query";
import { getProductStockBalancesApi } from "../api/stockBalancesApi";
import type { ProductId, StoreId } from "@KassaroAB/shared/types/ids";

export const useGetProductStockBalancesQuery = (
  storeId: StoreId | null,
  productId: ProductId | null,
) => {
  return useQuery({
    queryKey: ["stores", storeId, "stockBalances", "products", productId],
    queryFn: () => getProductStockBalancesApi(storeId!, productId!),
    enabled: !!storeId && !!productId,
  });
};
